import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { "data-testId": "studio-code-editor" }
const _hoisted_2 = { class: "tw-relative" }
const _hoisted_3 = { "data-testId": "characters-used" }
const _hoisted_4 = {
  key: 0,
  "data-testId": "character-limit"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, " Characters", -1)
const _hoisted_6 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["tw-absolute tw-right-0 tw-top-[-18px] tw-mr-1 tw-text-xs", [_ctx.characterLimit > 0 && _ctx.charactersUsed > _ctx.characterLimit ? 'tw-text-red-500' : 'tw-text-gray-500']])
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.charactersUsed), 1),
        (_ctx.characterLimit > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " / " + _toDisplayString(_ctx.characterLimit), 1))
          : _createCommentVNode("", true),
        _hoisted_5
      ], 2)
    ]),
    _createElementVNode("div", { id: _ctx.cmContainerId }, null, 8, _hoisted_6)
  ]))
}